import {
  convertDatetimeLocalToUTCInTimezone,
  convertLocalToUTC,
  scheduledDateToDatetimeLocalInTimezone,
  scheduledDateToDatetimeLocalInput,
  getUserTimezone,
} from "./dateTimeUtils";

/**
 * When the run timezone select changes, keep the same UTC instant and re-express it in the new zone
 * (or browser-local when clearing timezone).
 */
export function recomputeScheduledDateTimeLocalForTimezoneChange(
  scheduledDateTimeLocal,
  prevTimezone,
  nextTimezone
) {
  if (!scheduledDateTimeLocal || typeof scheduledDateTimeLocal !== "string") return scheduledDateTimeLocal;
  const prevTz = (prevTimezone ?? "").trim();
  const nextTz = (nextTimezone ?? "").trim();
  if (prevTz === nextTz) return scheduledDateTimeLocal;
  try {
    let utcIso;
    if (prevTz) {
      utcIso = convertDatetimeLocalToUTCInTimezone(scheduledDateTimeLocal, prevTz);
    } else {
      const localDate = new Date(scheduledDateTimeLocal);
      if (Number.isNaN(localDate.getTime())) return scheduledDateTimeLocal;
      utcIso = convertLocalToUTC(localDate, getUserTimezone());
    }
    if (nextTz) {
      return scheduledDateToDatetimeLocalInTimezone(utcIso, nextTz);
    }
    return scheduledDateToDatetimeLocalInput(utcIso);
  } catch {
    return scheduledDateTimeLocal;
  }
}

export const CONSOLE_EDIT_RUN_CLUB_NOTES_SLOTS = 3;
